/**
 * Renders the filter buttons based on global filters.
 * @return {Promise} A promise that resolves after rendering.
 */
export default () => {
	return new Promise((resolve) => {
		let sharedFilters = '';
		let sharedFiltersClear = false;
		const buttonHTML = `  `;

		// Taxonomies
		Object.entries(global.filters.taxonomies).forEach(([key, item]) => {
			if (item.terms !== undefined && item.terms.length > 0) {
				item.terms.forEach((term) => {
					if (term[1] !== undefined && key !== 'document_type') {
						const html = `<li><button aria-label="Remove filter: ${term[1].replaceAll(
							'+',
							' '
						)}" class="js-gsfc-filter-draw-tax govuk-tag max-w-fit mr-2 mb-0 cursor-pointer inline-block px-3 py-2" data-tax="${key}" data-value="${
							term[0]
						}">${term[1].replaceAll(
							'+',
							' '
						)} ${buttonHTML}</button></li>`;

						sharedFilters += html;
						sharedFiltersClear = true;
					}
				});
			}
		});

		// Dates
		if (
			global.filters.date_range_from !== '' ||
			global.filters.date_range_to !== ''
		) {
			let to = `Now`;
			let from = `All Time`;
			if (global.filters.date_range_from !== '') {
				const split = global.filters.date_range_from.split('-');
				const format = `${split[2]}/${split[1]}/${split[0]}`;
				from = `${format}`;
			}
			if (global.filters.date_range_to !== '') {
				const split = global.filters.date_range_to.split('-');
				const format = `${split[2]}/${split[1]}/${split[0]}`;
				to = `${format}`;
			}
			sharedFilters += `<li><button aria-label="Remove filter: ${from} - ${to}" class="js-gsfc-filter-draw-date govuk-tag max-w-fit mr-2 mb-0 cursor-pointer inline-block px-3 py-2">${from} - ${to} ${buttonHTML}</button></li>`;
			sharedFiltersClear = true;
		}

		// Order
		if (global.filters.order !== '') {
			let orderLabel = global.filters.order;
			if (orderLabel === 'TitleA') {
				orderLabel = 'Title A-Z';
			}
			if (orderLabel === 'TitleZ') {
				orderLabel = 'Title Z-A';
			}
			sharedFilters += `<li><button aria-label="Sorted by: ${orderLabel}" aria-disabled="true" class="js-gsfc-filter-draw-order govuk-tag max-w-fit mr-2 mb-0 cursor-pointer inline-block px-3 py-2">Sorted by: ${orderLabel}</button></li>`;
		}

		// Post types
		if (document.querySelectorAll('.js-gsfc-filter-post-type').length > 0) {
			// Only show this if the filters are present
			if (
				global.filters.post_types !== '' &&
				global.filters.post_types !== undefined
			) {
				const postTypes = global.filters.post_types;
				postTypes.forEach((postType) => {
					const postTypeOriginal = postType;
					//Remove hyphens
					postType = postType.replace(/-/g, ' ');
					let capitalized =
						postType.charAt(0).toUpperCase() + postType.slice(1);
					//Patch for services and resources
					if (capitalized === 'Services resources') {
						capitalized = 'Services and resources';
					}
					if (capitalized === 'Post') {
						capitalized = 'News';
					}

					sharedFilters += `<li><button aria-label="Remove filter: ${capitalized}" class="js-gsfc-filter-draw-post-type govuk-tag max-w-fit mr-2 mb-0 cursor-pointer px-3 py-2" data-post-type="${postTypeOriginal}">${capitalized} ${buttonHTML}</button></li>`;
					sharedFiltersClear = true;
				});
			}
		}

		if (sharedFiltersClear) {
			sharedFilters += `<li class="clear-filters"><button aria-label="Remove all filters" class="js-gsfc-filter-draw-clear govuk-tag max-w-fit govuk-tag max-w-fit--grey mr-2 mb-0 cursor-pointer bg-gsg-tomato-red text-white inline-block px-3 py-2">Remove all ${buttonHTML}</button></li>`;
		}

		// Render
		document.querySelector('.js-gsfc-filter-draw').innerHTML =
			sharedFilters;

		resolve();
	});
};
